import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { MuniV2Schema } from './order.service.types';
import { Order } from '../types/order.types';

@Injectable()
export class OrderService {
  private apiHost: string;

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) environmentConfig: EnvironmentConfig
  ) {
    this.apiHost = environmentConfig.params.apiHost as string;
  }

  public getOrders(dealId: string): Observable<Order[]> {
    return this.http
      .get<MuniV2Schema.Order[]>(
        `${this.apiHost}/api/v2/issues/${dealId}/orders`,
        {
          observe: 'response',
        }
      )
      .pipe(
        mergeMap((response) => {
          const data = response.status === 200 && response.body;
          return data
            ? of(data.map(MuniV2Schema.toOrder))
            : throwError(Error('No orders'));
        })
      );
  }
}
